import { FC, ReactElement } from 'react';

import { Page } from '../../../components';
import { ConnectedBlockRenderer, ConnectedPageHelmet } from '../../../connectors';
import { AppRoute } from '../../../entities/Routing/Routing';

import './CustomerServiceOrderingPage.scss';

export const CustomerServiceOrderingPage: FC = (): ReactElement => (
    <Page className="customer-service-ordering-page">
        <ConnectedPageHelmet appRoute={AppRoute.customerServiceOrdering} />
        <ConnectedBlockRenderer appRoute={AppRoute.customerServiceOrdering} />
    </Page>
);
